import { Link } from "react-router-dom";
import styled from "styled-components";

const AppLink = styled(Link)`
  text-decoration: none;
  color: darkgrey;

  &:hover {
    // text-decoration: underline;
    color: black;
  }
`;

export default AppLink;
